import request from "@/utils/request";

// 创建推荐活动
export const createEvent = (data) => {
    return request({
        url: "/businessservice/event/create",
        method: "post",
        data: data
    })
}

// 更新推荐活动
export const updateEvent = (data) => {
    return request({
        url: "/businessservice/event/update",
        method: "post",
        data: data
    })
}

// 分页查询推荐活动
export const pageEvent = (data) => {
    return request({
        url: "/businessservice/event/page",
        method: "post",
        data: data
    })
}

// 查询推荐活动信息
export const  infoEvent =(query) =>{
    return request({
        url: "/businessservice/event/info",
        method:"get",
        params: query
    })
}

// 删除推荐活动信息
export const  deleteEvent =(query) =>{
    return request({
        url: "/businessservice/event/delete",
        method:"get",
        params: query
    })
}

